export default __webpack_public_path__ + "static/media/vouchers.ad7448d8.svg";